import request from "@/utils/request";

// 上传
export function upload(data) {
  return request({
    url: "/system/file/fileUpload",
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data,
  });
}
// 删除图片接口
export function deletePic(id) {
  return request({
    url: "/system/file/"+id,
    method: "DELETE",
  });
}

